'use client';

import { Divider, Title, TitleLevels, TitleMarkup, TrilogyColor, View } from '@bytel/trilogy-react-ts';

import { CartType, OptionType } from '@app-types/product';
import { TagEventType } from '@app-types/tracking';

import useTracking from '@hooks/use-tracking';

import { OptionWithPrice } from './option-with-price';

interface OptionsListProps {
    classnames?: string;
    updatable?: boolean;
    showDivider?: boolean;
    cart: CartType;
    updateCartOptions?: (option: OptionType) => void;
}
export function OptionsList({
    classnames = 'has-text-left',
    updatable,
    showDivider,
    cart,
    updateCartOptions,
}: Readonly<OptionsListProps>) {
    const { sendTag } = useTracking();
    const handelDeleteOption = (o: OptionType) => {
        if (!cart?.product) return;

        if (updateCartOptions) {
            updateCartOptions(o);
            if (o.gencode === cart.product.option5g?.gencode) {
                sendTag(
                    {
                        actionClic: 'Clic_deselection',
                        categorieClic: 'Parcours_configurateur_5g',
                        nomClic: 'Suppression_option_5g',
                    },
                    TagEventType.CLICK,
                );
            }
        }
    };
    if (!cart.options?.length) return null;

    return (
        <>
            {showDivider && <Divider color={TrilogyColor.GREY_LIGHT} />}

            <View className={classnames}>
                <Title level={TitleLevels.THREE} markup={TitleMarkup.H3}>
                    Vos options
                </Title>
                {cart.options.map((option) => (
                    <OptionWithPrice
                        subTitle={option.promoLabel}
                        amount={option.price}
                        subTitleClassName='has-text-primary'
                        period='mois'
                        small_image={option.image}
                        handleDelete={() => handelDeleteOption(option)}
                        key={option.gencode}
                        updatable={updatable}
                        priceLevel={5}
                        alt={option.name}
                    />
                ))}
            </View>
        </>
    );
}
